<div class="filter_overlay"></div>

<div class="modal-contador" [ngClass]="'info'">
	<span *ngIf="showButtonClose" class="cerrar_modales" (click)="clickAcept()"
		><img src="assets/images/close_modal.png" alt="cerrar"
	/></span>
	<div class="modal-content">
		<img src="assets/images/paso-siguiente.png" style="cursor: pointer" alt="enviar" (click)="clickAcept()" />
		<p>{{ title }}</p>
		<div class="contador">
			<h3 style="margin: 0; padding: 0">
				{{ time }}
			</h3>
		</div>
	</div>

	<div class="botones_modales" style="margin-top: 5px !important">
		<!-- <a *ngIf="showButtonCancel" class="button boton_cancelar" (click)="clickCancel()">{{ textSecondButton }}</a> -->
		<a class="button" style="background: #0071b9 !important" (click)="clickCancel()">{{ textFirstButton }}</a>
	</div>
</div>
